import Button from 'components/button';
import styles from './style.module.scss';
import { Link, useParams } from 'react-router-dom';
import FacilityCompanyEmergencyContactsApi from 'libs/api/facility/companyEmergencyContacts';
import { useEffect, useState } from 'react';

const api = new FacilityCompanyEmergencyContactsApi();

const EmergencyContactsConfirm = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      (async () => {
        try {
          await api.confirm(token);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [token]);

  return (
    <div className={styles.container}>
      <Link to={'/'}>
        <Button loading={loading}>Home</Button>
      </Link>
    </div>
  );
};

export default EmergencyContactsConfirm;
